import { render, staticRenderFns } from "./TerminalComponent.vue?vue&type=template&id=5c13a8cd"
import script from "./TerminalComponent.vue?vue&type=script&lang=js"
export * from "./TerminalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports